<button
  *ngIf="canManageIntegrations"
  type="button"
  class="epp-sync-settings-button p-link"
  pTooltip="Configurar sincronizaciones"
  tooltipPosition="right"
  (click)="openSettings()">
  <i class="pi pi-cog"></i>
</button>

<p-dialog
  *ngIf="canManageIntegrations"
  [(visible)]="visible"
  [modal]="true"
  appendTo="body"
  [dismissableMask]="false"
  header="Sincronizaciones"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [contentStyle]="{ height: '75vh', padding: '0' }">

  <div class="flex h-full">

    <!-- Menú de opciones (izquierda) -->
    <div class="sync-settings-menu-col flex-shrink-0 border-right-1 surface-border py-3">
      <ul class="list-none p-0 m-0">
        <li *ngFor="let item of menuItems">
          <button
            type="button"
            class="sync-settings-menu-item w-full p-link flex align-items-center gap-2 px-3 py-2"
            [class.active]="view === item.key"
            (click)="selectItem(item.key)">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </button>
        </li>
      </ul>
    </div>

    <!-- Contenido de la opción seleccionada (derecha) -->
    <div class="flex-1 overflow-auto p-4">
      <app-epp-integrations *ngIf="view === 'epp-integration'"></app-epp-integrations>
      <app-user-sync-settings *ngIf="view === 'user-sync'"></app-user-sync-settings>
      <app-inventory-sync-settings *ngIf="view === 'inventory-sync'"></app-inventory-sync-settings>
      <div *ngIf="view === 'menu'" class="flex flex-column align-items-center justify-content-center h-full text-center">
        <i class="pi pi-arrow-left text-4xl text-300 mb-3"></i>
        <p class="text-400">Selecciona una opción del menú</p>
      </div>
    </div>

  </div>
</p-dialog>
